import React from "react";
import { AiOutlineInfoCircle, AiOutlineCheckCircle } from "react-icons/ai";
import { IoCloseOutline } from "react-icons/io5";
import { useDispatch } from "react-redux";
import { removeAppError } from "../store/userSlice";

export default function Toast({ msg, id, color }) {
  const dispatch = useDispatch();

  const bgClass =
    color === "success"
      ? "bg-green-700"
      : color === "error" || !color
      ? "bg-red"
      : color; // allow raw tailwind class like "bg-blue"

  const Icon = color === "success" ? AiOutlineCheckCircle : AiOutlineInfoCircle;

  return (
    <div
      className={`flex gap-3 items-start w-full p-3 text-white rounded-lg shadow-lg mb-2 ${bgClass}`}
      role="alert"
    >
      {/* Icon */}
      <div className="flex-shrink-0 mt-0.5">
        <Icon size="1.4rem" />
      </div>

      {/* Message */}
      <div className="flex-1 text-sm font-normal leading-snug break-words min-w-0">
        {msg}
      </div>

      {/* Close */}
      <button
        type="button"
        className="flex-shrink-0 mt-0.5 rounded-md p-1 hover:bg-white/20 transition-colors"
        onClick={() => dispatch(removeAppError(id))}
        aria-label="Close"
      >
        <IoCloseOutline size="1.2rem" />
      </button>
    </div>
  );
}
